import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { useCurrentUserJwt } from '@dtx-company/inter-app/src/redux/selectors/currentUserSelectors'
import { useEffect, useRef } from 'react'
import { useFlowFeatureContext } from '@dtx-company/inter-app/src/hooks/useFlowFeature/context/useFlowFeatureContext'

export function CaptureOptimizelyValues(): null {
  const jwt = useCurrentUserJwt()
  const isAuthenticated = Boolean(jwt?.token)
  const flowFeatureContext = useFlowFeatureContext()
  const ref = useRef(false)

  useEffect(() => {
    if (
      isAuthenticated &&
      flowFeatureContext.attributesReady &&
      !ref.current &&
      window &&
      window.flow?.feature?.getCache
    ) {
      ref.current = true
      const optimizelyValues = Object.fromEntries(
        Object.entries(window.flow?.feature?.getCache() || {}).map(([key, value]) => [
          key,
          value[0]
        ])
      )
      fireAnalyticsEvent('userAuthenticated_optimizelyValues', {
        ...optimizelyValues
      })
    }
  }, [flowFeatureContext.attributesReady, isAuthenticated])

  return null
}
